"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandymanProfession = void 0;
var zod_1 = require("zod");
var HandymanProfession;
(function (HandymanProfession) {
    HandymanProfession.Schema = zod_1.z.enum(["electrician", "plumber", "plumber-spolbil"]);
})(HandymanProfession || (HandymanProfession = {}));
exports.HandymanProfession = HandymanProfession;
